import {BaseHttp, FigmaStatusRes, IFigmaFileMeta, IIntervalSetting, IPeriodSetting} from "@atl/lacerta-ui-common";
import {Injectable} from "@angular/core";
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {Observable} from "rxjs";
import {
    ArchiveSettings,
    FigmaSettings,
    HmiSettings,
    PasswordsSettings,
    Settings
} from "@app/administration/settings/interfaces/settings.interface";
import {InterceptorSkipHeader} from "@app/interceptors/error-interceptor";

@Injectable({
    providedIn: 'root'
})
export class SettingsHttpService extends BaseHttp {
    constructor(private http: HttpClient) {
        super();
    }

    getSettings(): Observable<Settings> {
        const url = `${this.apiRoot}/settings`;
        return this.http.get<Settings>(url, {withCredentials: true});
    }

    setArchiveSettings(settings: ArchiveSettings): Observable<ArchiveSettings> {
        const url = `${this.apiRoot}/settings/archive`;
        return this.http.put<ArchiveSettings>(url, settings, {withCredentials: true});
    }

    setFigmaSettings(settings: FigmaSettings): Observable<FigmaSettings> {
        const url = `${this.apiRoot}/settings/figma`;
        return this.http.put<FigmaSettings>(url, settings, {withCredentials: true});
    }

    getFigmaFiles(skipError: boolean = false): Observable<IFigmaFileMeta[]> {
        const url = `${this.apiRoot}/figma/files`;
        let headers: HttpHeaders
        if (skipError) {
            headers = new HttpHeaders().set(InterceptorSkipHeader, '');
        }
        return this.http.get<IFigmaFileMeta[]>(url, {withCredentials: true, headers});
    }

    syncFigma(): Observable<null> {
        const url = `${this.apiRoot}/figma/sync`;
        return this.http.get<null>(url, {withCredentials: true});
    }

    getFigmaStatus(): Observable<FigmaStatusRes> {
        const url = `${this.apiRoot}/figma/sync/status`;
        return this.http.get<FigmaStatusRes>(url, {withCredentials: true});
    }

    createPeriod(period: Omit<IPeriodSetting, 'id'>): Observable<IPeriodSetting> {
        const url = `${this.apiRoot}/settings/trends/periods`;
        return this.http.post<IPeriodSetting>(url, period, {withCredentials: true});
    }

    editPeriod(period: IPeriodSetting): Observable<IPeriodSetting> {
        const url = `${this.apiRoot}/settings/trends/periods/${period.id}`;
        return this.http.put<IPeriodSetting>(url, period, {withCredentials: true});
    }

    deletePeriod(period: IPeriodSetting): Observable<null> {
        const url = `${this.apiRoot}/settings/trends/periods/${period.id}`;
        return this.http.delete<null>(url, {withCredentials: true});
    }

    deleteIntervals(interval: IIntervalSetting): Observable<null> {
        const url = `${this.apiRoot}/settings/trends/periods/interval/${interval.id}`;
        return this.http.delete<null>(url, {withCredentials: true});
    }

    setHmiSettings(settings: HmiSettings): Observable<HmiSettings> {
        const url = `${this.apiRoot}/settings/hmi`;
        return this.http.put<HmiSettings>(url, settings, {withCredentials: true});
    }

    setPasswordsSettings(settings: PasswordsSettings): Observable<PasswordsSettings> {
        const url = `${this.apiRoot}/settings/users/password`;
        return this.http.put<PasswordsSettings>(url, settings, {withCredentials: true});
    }
}
